
import util from '../../../util'


const loadProfileList = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()


    payload.context.axios.get('api/profiles', {headers}).then((response) => {


      commit('setProfileList', response.data)
      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar los perfiles.')
        reject(error.response)
      }
      reject(error.response)

    });

  })

}



const saveProfile = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post('api/profiles',payload.profile ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al registrar el perfil.')
        reject(error.response)
      }
      reject()

    });

  })

}


const editProfile = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.put('api/profiles',payload.profile ,{headers}).then((response) => {

      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        util.showDialogError(payload.context, 'Ocurrió un error al actualizar el perfil.')
        reject(error.response)
      }
      reject()

    });

  })

}

const deleteProfile = ({commit}, payload) =>{

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.delete('api/profiles/'+payload.profile.id ,{headers}).then((response) => {
      resolve(response.data)

    }).catch(error => {
      if(error.response)
      {
        console.log(error)
        util.showDialogError(payload.context, 'Ocurrió un error al eliminar el perfil.')
        reject(error.response)
      }
      reject()

    });

  })

}

export default {
  loadProfileList,saveProfile,editProfile, deleteProfile
};






// WEBPACK FOOTER //
// ./src/store/modules/profile/actions.js